import React from 'react'
import {
    Button,
    Dropdown,
    Grid,
    Message,
    Header,
    Divider,
    Image,
    Progress
} from "semantic-ui-react";
import _ from "lodash";
import DialogButton from "./DialogButton";
import '../../style.css'

function Dialog(
    {
        dialogQuestions,
        hiddenQuestions,
        showQuestion,
        dialogResponses,
        saveDialog,
        pastDialog,
        responseSelected,
        questionSelected,
        handleResponseSelected,
        ending,
        handleRestart,
        assignmentNumber,
        assignmentOptions,
        speakerOptions,
        speakerNum,
        handleAssignmentChange,
        handleSpeakerChange,
        handleQuestionSelected,
        hiddenResponses,
        showResponse,
        starting,
        startDialog,
        savedQuestion,
        savedResponse,
        speakerHeadImages,
        questionTurn,
        loading,
        progress,
        progressText,
        assignmentChosen
    }
) {
    const disabledQuestion = (
        <Grid className='center aligned'>
            <Grid.Row style={{marginTop: 10}} columns={4}>
                <Grid.Column>
                    <Grid.Row>
                        {
                            speakerNum ?
                                <Header as='h3' style={{color: '#007d0f'}}>
                                    {savedQuestion.speakA}
                                </Header>
                                :
                                <Header as='h3' style={{color: '#07008c'}}>
                                    {savedQuestion.speakA}
                                </Header>
                        }

                    </Grid.Row>
                    <Grid.Row>
                        <Header as='h5' color='grey'>
                            ({savedQuestion.speakA_eng})
                        </Header>
                    </Grid.Row>
                </Grid.Column>
                <Grid.Column>
                    <DialogButton
                        file={savedQuestion.speakA_audio}
                        id={0}
                        size='tiny'
                        color='yellow'
                        name='Replay'
                    />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );

    const disabledResponse = (
        <Grid className='center aligned'>
            <Grid.Row style={{marginTop: 10}} columns={4}>
                <Grid.Column>
                    <Grid.Row>
                        {
                            speakerNum ?
                                <Header as='h3' style={{color: '#07008c'}}>
                                    {savedResponse.speakB}
                                </Header>
                                :
                                <Header as='h3' style={{color: '#007d0f'}}>
                                    {savedResponse.speakB}
                                </Header>
                        }

                    </Grid.Row>
                    <Grid.Row>
                        <Header as='h5' color='grey'>
                            ({savedResponse.speakB_eng})
                        </Header>
                    </Grid.Row>
                </Grid.Column>
                <Grid.Column>
                    {
                        savedResponse.speakB_audio === '' ?
                            null
                            :
                            <DialogButton
                                file={savedResponse.speakB_audio}
                                id={0}
                                size='tiny'
                                color='yellow'
                                name='Replay'
                            />
                    }

                </Grid.Column>
            </Grid.Row>
        </Grid>
    );

    const questions = _.times(dialogQuestions.length, (i) => (
        <Grid className='center aligned' key={i}>
            <Grid.Row style={{marginTop: 10}} columns={4}  >
                {
                    speakerNum ?
                        hiddenQuestions[i] ?
                            <>
                                <Grid.Column>
                                    <Grid.Row>
                                        <Header as='h3' style={{color: '#007d0f'}}>
                                            {dialogQuestions[i].speakA}
                                        </Header>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Header as='h5' color='grey'>
                                            ({dialogQuestions[i].speakA_eng})
                                        </Header>
                                    </Grid.Row>
                                </Grid.Column>
                                <Grid.Column>
                                    <DialogButton
                                        file={dialogQuestions[i].speakA_audio}
                                        id={i}
                                        size='tiny'
                                        showResponse={handleQuestionSelected}
                                        name='Choose'
                                        style={questionTurn ? 'buttonIndicator' : null}
                                    />
                                </Grid.Column>
                            </>

                            :
                            <>
                                <Grid.Column>
                                    <Grid.Row>
                                        <Header as='h3' style={{color: '#007d0f'}}>
                                            {dialogQuestions[i].speakA}
                                        </Header>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Header as='h5' color='grey'>
                                            ({dialogQuestions[i].speakA_eng})
                                        </Header>
                                    </Grid.Row>
                                </Grid.Column>
                                <Grid.Column>
                                    <DialogButton
                                        file={dialogQuestions[i].speakA_audio}
                                        id={i}
                                        size='tiny'
                                        color='yellow'
                                        fontColor='white'
                                        showResponse={handleQuestionSelected}
                                        name='Replay'
                                    />
                                </Grid.Column>
                            </>
                        :
                        hiddenQuestions[i] ?
                            <>
                                <Grid.Column>
                                    <Grid.Row>
                                        <Header as='h3' style={{color: '#07008c'}}>
                                            ???
                                        </Header>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Header as='h5' color='grey'>
                                            ({dialogQuestions[i].speakA_eng})
                                        </Header>
                                    </Grid.Row>
                                </Grid.Column>
                                <Grid.Column>
                                    <DialogButton
                                        file={dialogQuestions[i].speakA_audio}
                                        id={i}
                                        size='tiny'
                                        showResponse={showQuestion}
                                        name='Choose'
                                        style={questionTurn ? 'buttonIndicator' : null}

                                    />
                                </Grid.Column>
                            </>

                            :
                            <>
                                <Grid.Column>
                                    <Grid.Row>
                                        <Header as='h3' style={{color: '#07008c'}}>
                                            {dialogQuestions[i].speakA}
                                        </Header>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Header as='h5' color='grey'>
                                            ({dialogQuestions[i].speakA_eng})
                                        </Header>
                                    </Grid.Row>
                                </Grid.Column>
                                <Grid.Column>
                                    <DialogButton
                                        file={dialogQuestions[i].speakA_audio}
                                        id={i}
                                        size='tiny'
                                        color='yellow'
                                        fontColor='black'
                                        showResponse={showQuestion}
                                        name='Replay'
                                    />
                                </Grid.Column>

                            </>

                }
            </Grid.Row>
        </Grid>
    ));

    const responses = _.times(dialogResponses.speakB.length, (i) => (
        <Grid className='center aligned'>
            <Grid.Row style={{marginTop: 10}} columns={4}>
                <>
                    {
                        speakerNum ?
                            hiddenResponses[i] ?
                                <>
                                    <Grid.Column>
                                        <Grid.Row>
                                            <Header as='h3' style={{color: '#07008c'}}>
                                                ???
                                            </Header>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Header as='h5' color='grey'>
                                                ({dialogResponses.speakB_eng[i]})
                                            </Header>
                                        </Grid.Row>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <DialogButton
                                            file={dialogResponses.speakB_audio[i]}
                                            id={i}
                                            size='tiny'
                                            showResponse={showResponse}
                                            name='Choose'
                                            style={!questionTurn && !responseSelected ? 'buttonIndicator' : null}

                                        />
                                    </Grid.Column>

                                </>
                                :
                                <>
                                    <Grid.Column>
                                        <Grid.Row>
                                            <Header as='h3' style={{color: '#07008c'}}>
                                                {dialogResponses.speakB[i]}
                                            </Header>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Header as='h5' color='grey'>

                                                ({dialogResponses.speakB_eng[i]})
                                            </Header>
                                        </Grid.Row>

                                    </Grid.Column>
                                    <Grid.Column>
                                        <DialogButton
                                            file={dialogResponses.speakB_audio[i]}
                                            color='yellow'
                                            id={i}
                                            fontColor='black'
                                            size='tiny'
                                            showResponse={showResponse}
                                            name='Replay'
                                        />
                                    </Grid.Column>

                                </>
                            :
                            hiddenResponses[i] ?
                                <>
                                    <Grid.Column>
                                        <Grid.Row>
                                            <Header as='h3' style={{color: '#007d0f'}}>
                                                {dialogResponses.speakB[i]}
                                            </Header>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Header as='h5' color='grey'>
                                                ({dialogResponses.speakB_eng[i]})
                                            </Header>
                                        </Grid.Row>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <DialogButton
                                            file={dialogResponses.speakB_audio[i]}
                                            id={i}
                                            size='tiny'
                                            showResponse={handleResponseSelected}
                                            name='Choose'
                                            style={!questionTurn && !responseSelected ? 'buttonIndicator' : null}

                                        />
                                    </Grid.Column>
                                </>
                                :
                                <>
                                    <Grid.Column>
                                        <Grid.Row>
                                            <Header as='h3' style={{color: '#007d0f'}}>
                                                {dialogResponses.speakB[i]}
                                            </Header>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Header as='h5' color='grey'>
                                                ({dialogResponses.speakB_eng[i]})
                                            </Header>
                                        </Grid.Row>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <DialogButton
                                            file={dialogResponses.speakB_audio[i]}
                                            id={i}
                                            size='tiny'
                                            color='yellow'
                                            showResponse={handleResponseSelected}
                                            name='Replay'
                                        />
                                    </Grid.Column>
                                </>


                    }
                </>
            </Grid.Row>
        </Grid>
    ));
    const dialog = (
        <div>
            <Grid className='center aligned'>
                <Grid.Row columns={2}>
                    <Grid.Column>
                        <Grid>
                            <Grid.Column className='dialogButton'>

                                {
                                    questions
                                }
                            </Grid.Column>
                        </Grid>
                    </Grid.Column>
                    <Grid.Column>
                        <Grid className='center aligned'>
                            <Grid.Column>

                                {
                                    questionSelected ?
                                        <>
                                            {
                                                responses.length < 1 ?
                                                    <Grid className='center aligned'>
                                                        <Grid.Row style={{marginTop: 10}} columns={4}>
                                                            <Grid.Column>
                                                                <Header as='h5' color='grey'>
                                                                    (No response)
                                                                </Header>
                                                            </Grid.Column>
                                                            <Grid.Column></Grid.Column>
                                                        </Grid.Row>
                                                    </Grid>
                                                    :
                                                    responses
                                            }
                                        </>
                                        :
                                        <>

                                        </>
                                }
                            </Grid.Column>

                        </Grid>
                    </Grid.Column>

                </Grid.Row>
            </Grid>
            <Divider/>
        </div>
    );

    const disabledDialog = (
        <div style={{opacity: 0.8}}>
            <Grid className='center aligned'>
                <Grid.Row columns={2}>
                    <Grid.Column>
                        <Grid>
                            <Grid.Column>

                                {
                                    disabledQuestion
                                }
                            </Grid.Column>
                        </Grid>
                    </Grid.Column>
                    <Grid.Column>
                        <Grid className='center aligned'>
                            <Grid.Column>

                                {
                                    questionSelected ?
                                        <>
                                            {
                                                disabledResponse
                                            }
                                        </>
                                        :
                                        <>

                                        </>
                                }
                            </Grid.Column>

                        </Grid>
                    </Grid.Column>

                </Grid.Row>
            </Grid>
            <Divider/>
        </div>
    );

    return (
        <>
            <br/>

            <div>
                <Grid className='center aligned'>
                    <Grid.Row>
                        <Header as='h1'>
                            Dialog Conversation Practice
                        </Header>
                    </Grid.Row>
                    <Grid.Row>
                        <Message color='teal'>
                            <p style={{color: 'black'}}>
                                Dialog assignments let you explore dialog scenarios.
                                <br/>
                                You can choose to act as the initiator of a conversation (Act as Speaker A) or the
                                responder
                                (Act as Speaker B) by selecting from the menu above.
                                <br/>
                                Follow the prompts below to choose the direction of your dialog. Whenever you see ???,
                                try
                                to think of what the Samoan translation should be.
                                <br/>
                                Use the dropdown below to choose an assignment to work on.
                            </p>
                        </Message>
                    </Grid.Row>
                    {
                        loading ?
                            <Grid.Row>
                                <Progress indicating progress percent={progress} style={{width: 400}}>
                                    {progressText}
                                </Progress>
                            </Grid.Row>
                            :
                            <Grid.Row>
                                <Dropdown
                                    onChange={handleAssignmentChange}
                                    options={assignmentOptions}
                                    placeholder='Choose an assignment'
                                    selection
                                    value={assignmentNumber}
                                />
                                {
                                    assignmentChosen ?
                                        <Dropdown
                                            style={{marginLeft: 10}}
                                            onChange={handleSpeakerChange}
                                            options={speakerOptions}
                                            placeholder='Act as Speaker B'
                                            selection
                                            value={speakerNum}
                                        />
                                        :
                                        null
                                }

                            </Grid.Row>
                    }

                    {
                        assignmentChosen ?
                            <Grid.Row columns={2}>
                                <Grid.Column>
                                    {
                                        speakerNum ?
                                            <Header as='h2'>Speaker A:</Header>
                                            :
                                            <Header as='h2' style={{color: '#07008c'}}>Speaker A: YOU</Header>

                                    }
                                    {
                                        <Image style={{
                                            width: 80,
                                            height: 130,
                                            marginLeft: 'auto',
                                            marginRight: 'auto',
                                            display: 'block'
                                        }} src={speakerHeadImages.rightFacingHead} size='tiny'/>
                                    }
                                </Grid.Column>
                                <Grid.Column>
                                    {
                                        speakerNum ?
                                            <Header as='h2' style={{color: '#07008c'}}>Speaker B: YOU</Header>
                                            :
                                            <Header as='h2'>Speaker B: </Header>

                                    }
                                    {
                                        <Image style={{
                                            width: 80,
                                            height: 130,
                                            marginLeft: 'auto',
                                            marginRight: 'auto',
                                            display: 'block'
                                        }} src={speakerHeadImages.leftFacingHead} size='tiny'/>
                                    }
                                </Grid.Column>

                            </Grid.Row>
                            :
                            null
                    }
                </Grid>
                {
                    assignmentChosen ?
                        <>
                            <div className='dialogButton'>
                                {pastDialog}
                                {dialog}
                            </div>
                            <Grid className='center aligned' style={{marginTop: -45}}>
                                <Grid.Row>
                                    {
                                        starting ?
                                            (questionSelected && responseSelected) ?
                                                <Button className='nextButtonIndicator' onClick={() => {
                                                    startDialog(disabledDialog)
                                                }}>Next</Button>
                                                :
                                                <Button disabled={true} onClick={() => {
                                                    startDialog(disabledDialog)
                                                }}>Next</Button>
                                            :
                                            ending ?
                                                (questionSelected && responseSelected) ?
                                                    <Button color='red' className='restartButton'
                                                            onClick={handleRestart}>Restart</Button>
                                                    :
                                                    <Button disabled={true} onClick={handleRestart}>Restart</Button>

                                                :
                                                (questionSelected && responseSelected) ?
                                                    <Button className='nextButtonIndicator' onClick={() => {
                                                        saveDialog(disabledDialog)
                                                    }}>Next</Button>
                                                    :
                                                    <Button disabled={true} onClick={() => {
                                                        saveDialog(disabledDialog)
                                                    }}>Next</Button>
                                    }
                                </Grid.Row>
                                <Grid.Row>
                                </Grid.Row>
                            </Grid>
                        </>
                        :
                        null

                }

            </div>

        </>
    )
}

export default Dialog
